import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import SecurityEHero from "./SecurityEHero";
import WhatWeDo from "./WhatWeDo";
import KeyFeatures from "./KeyFeatures";
import WhyShouldLaunch from "./WhyShouldLaunch";

import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function SecurityExchange() {
  return (
    <div>
      <Header />
      <SecurityEHero />
      <WhatWeDo />
      <WhyShouldLaunch />
      <KeyFeatures />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default SecurityExchange;
